import { render } from "./ShowButton.vue?vue&type=template&id=953f31c6&scoped=true"
import script from "./ShowButton.ts?vue&type=script&lang=js"
export * from "./ShowButton.ts?vue&type=script&lang=js"

import "./ShowButton.vue?vue&type=style&index=0&id=953f31c6&lang=scss&scoped=true"

import exportComponent from "/Users/lucatescari/Documents/Projects/Private/rt-songpage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-953f31c6"]])

export default __exports__